import React from 'react';
import AboutSection from '../components/home/AboutSection';

const About = () => {
  return (
    <>
      <section className="page-header">
        <div className="container">
          <h1>About Us</h1>
          <p>
            BSB is a tech-driven industrial raw material distribution platform with an integrated supply chain ecosystem,
            focused on transforming how B2B trade operates.
          </p>
        </div>
      </section>
      <AboutSection />
    </>
  );
};

export default About;

